import { types as coreTypes } from '@sitebuilder/core';

const schema = (title: string = 'HighChart Options'): coreTypes.Schema => ({
    options: {
        type: 'array',
        title,
        items: {
            type: 'object',
            properties: {
                path: { type: 'string', description: 'Options Object Path' },
                valueType: {
                    type: 'string',
                    enum: ['jsonString', 'function'],
                    description: 'Type of value',
                    default: 'jsonString',
                },
            },
            dependencies: {
                valueType: {
                    oneOf: [
                        {
                            properties: {
                                valueType: { enum: ['jsonString'] },
                                value: {
                                    type: 'string',
                                    description: 'HighChart Options as JSON string',
                                },
                            },
                        },
                        {
                            properties: {
                                valueType: { enum: ['function'] },
                                functionToTransform: {
                                    type: 'string',
                                    description: 'Function',
                                    default:
                                        // eslint-disable-next-line max-len
                                        'return () => { }',
                                },
                            },
                        },
                    ],
                },
            },
        },
    },
});

const uiSchema = {
    options: {
        items: {
            path: {
                'ui:widget': 'CustomTextInput',
            },
            value: {
                'ui:widget': 'CustomTextInput',
            },
            valueType: {
                'ui:widget': 'CustomSelect',
            },
            functionToTransform: { 'ui:widget': 'JSEditor' },
        },
    },
};

export const HighchartOptionsSchema = {
    schema,
    uiSchema,
};
